var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('a-config-provider',{attrs:{"locale":_vm.zhCN}},[_c('router-view')],1),_c('a-back-top',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"back"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }